




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EsmsForm extends Vue {
  @Prop() private spec!: object;
  @Prop() private value!: object;
}
